import React, { Component } from 'react';
import { GenericSimpleButton, GenericModal } from 'com-gyf-webcore-userinterfacecomponents';

class EliminarAdicionalModal extends Component {
    constructor(props) {
        super(props);
        this.handleClick = this.handleClick.bind(this);
    }

    handleClick(value){
        if(value == "aceptar"){
            this.props.toggleModal("EliminarAdicional");
            this.props.borrarClienteAdicional(this.props.idAdicional);
        }else{
            this.props.toggleModal("EliminarAdicional");
        }
    }
    
    render() {
        return (
                <div className="modal fade-out" id="EliminarAdicional" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true" data-backdrop="static">
                    <div className="modal-dialog">
                            <div className="modal-content modal-wide">
                                <div className="modal-header-new">
                                    <div className="closeNew" data-dismiss="modal" aria-hidden="true"><label className="ti-close clickable"></label></div>
                                    <h2 className="modal-title-new" id="myModalLabel">Eliminar tarjeta</h2>
                                </div>
                                <div className="modal-body-new">¿Confirma que desea eliminar la solicitud para este integrante de cuenta?</div>
                                <div className="modal-footer-new">
                                    <button className="btn btn-cta" onClick={()=>this.handleClick("aceptar")} >Sí</button>
                                    <button className="btn btn-secondary button-separation-foot" onClick={()=>this.handleClick("cancelar")}>No</button>
                                </div>
                        </div>
                    </div>
                </div>
        );
    }
};

export default EliminarAdicionalModal